import { Grid } from '@material-ui/core'
import ViewDocs from './ViewDocs'

const ViewWrapperDocs = ({ record }) => {
  return (
    <Grid
      container
      justifyContent="center"
      style={{ margin: 'auto', marginBottom: 16 }}
      xs={11}
      md={6}
    >
      <ViewDocs record={record} />
    </Grid>
  )
}
export default ViewWrapperDocs
